import { render } from "./AddNewToolModalDialog.vue?vue&type=template&id=b4bd3ae8&scoped=true&ts=true&lang=pug"
import script from "./AddNewToolModalDialog.vue?vue&type=script&lang=ts"
export * from "./AddNewToolModalDialog.vue?vue&type=script&lang=ts"

import "./AddNewToolModalDialog.vue?vue&type=style&index=0&id=b4bd3ae8&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4bd3ae8"]])

export default __exports__